import { IPartnerBankDetails } from '../../store/payments/payments-interfaces-helper';

export enum PARTNER_BANK_FORM_FIELD {
	ACCOUNT_TYPE = 'accountType',
	ACCOUNT_NUMBER = 'accountNumber',
	ROUTING_NUMBER = 'routingNumber',
	BANK_NAME = 'bankName',
	CURRENCY = 'currency',
	ACCOUNT_NAME = 'accountName',
}

export enum PARTNER_BANK_FORM_FIELD_NAMES {
	ACCOUNT_TYPE = 'NEW_APPLICATION.LABEL.DDA_TYPE',
	ACCOUNT_NUMBER = 'NEW_APPLICATION.LABEL.ACCOUNT_NUMBER',
	ROUTING_NUMBER = 'NEW_APPLICATION.LABEL.ROUTING_NUMBER',
	BANK_NAME = 'NEW_APPLICATION.LABEL.BANK_NAME',
	CURRENCY = 'NEW_APPLICATION.LABEL.CURRENCY',
	ACCOUNT_NAME = 'NEW_APPLICATION.LABEL.ACCOUNT_NAME',
	ACCOUNT_NAME_TOOLTIP = 'NEW_APPLICATION.LABEL.ACCOUNT_NAME_TOOLTIP',
}

export type PartnerBankFieldsTypes = {
	[PARTNER_BANK_FORM_FIELD.ACCOUNT_TYPE]: string;
	[PARTNER_BANK_FORM_FIELD.ACCOUNT_NUMBER]: string;
	[PARTNER_BANK_FORM_FIELD.ROUTING_NUMBER]: string;
	[PARTNER_BANK_FORM_FIELD.BANK_NAME]: string;
	[PARTNER_BANK_FORM_FIELD.CURRENCY]: string;
	[PARTNER_BANK_FORM_FIELD.ACCOUNT_NAME]?: string;
}

export type PartnerBankFieldsReturnTypes = {
	accountType: string;
	accountNumber: string | null;
	routingNumber: string | null;
	bankName: string;
	relatedEntityType?: string;
	relatedEntityId?: string;
	currency: string;
	accountName?: string;
}

export const partnerBankInitialValues: PartnerBankFieldsTypes = {
	[PARTNER_BANK_FORM_FIELD.ACCOUNT_TYPE]: '',
	[PARTNER_BANK_FORM_FIELD.ACCOUNT_NUMBER]: '',
	[PARTNER_BANK_FORM_FIELD.ROUTING_NUMBER]: '',
	[PARTNER_BANK_FORM_FIELD.BANK_NAME]: '',
	[PARTNER_BANK_FORM_FIELD.CURRENCY]: '',
	[PARTNER_BANK_FORM_FIELD.ACCOUNT_NAME]: '',
};

export const getFormattedPartnerBankFormFields = (formikValues): PartnerBankFieldsReturnTypes => ({
	accountType: formikValues?.[PARTNER_BANK_FORM_FIELD.ACCOUNT_TYPE] || null,
	accountNumber: formikValues?.[PARTNER_BANK_FORM_FIELD.ACCOUNT_NUMBER] || null,
	routingNumber: formikValues?.[PARTNER_BANK_FORM_FIELD.ROUTING_NUMBER] || null,
	bankName: formikValues?.[PARTNER_BANK_FORM_FIELD.BANK_NAME] || null,
	relatedEntityType: 'Partner',
	currency: formikValues?.[PARTNER_BANK_FORM_FIELD.CURRENCY] || null,
	accountName: formikValues?.[PARTNER_BANK_FORM_FIELD.ACCOUNT_NAME] || null,
});

export const convertPartnerBankFieldsToInitial = (data: IPartnerBankDetails): PartnerBankFieldsTypes => ({
	[PARTNER_BANK_FORM_FIELD.ACCOUNT_TYPE]: data?.accountType ?? '',
	[PARTNER_BANK_FORM_FIELD.ACCOUNT_NUMBER]: data?.accountNumber ?? '',
	[PARTNER_BANK_FORM_FIELD.ROUTING_NUMBER]: data?.routingNumber ?? '',
	[PARTNER_BANK_FORM_FIELD.BANK_NAME]: data?.bankName ?? '',
	[PARTNER_BANK_FORM_FIELD.CURRENCY]: data?.currency ?? '',
	[PARTNER_BANK_FORM_FIELD.ACCOUNT_NAME]: data?.accountName ?? '',
});

export const getFormattedPartnerBankData = (data: IPartnerBankDetails): PartnerBankFieldsReturnTypes => ({
	accountType: data?.accountType ?? null,
	accountNumber: data?.accountNumber ?? null,
	routingNumber: data?.routingNumber ?? null,
	bankName: data?.bankName ?? null,
	relatedEntityType: 'Partner',
	currency: data?.currency ?? null,
	accountName: data?.accountName ?? null,
});
